/*=========================================================================================
  File Name: moduleStatusMobileMutations.js
  Description: Status Mobile Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
	// Asigna los status al state
	SET_STATUS(state, status) {
		state.status = status;
	},
	SET_STATUS_MOBILE(state, statusMobile) {
		state.statusMobile = statusMobile || [];
	},
	SET_COMPANIES(state, companies) {
		state.companies = companies;
	},
	// Insertar status individual al state
	SET_STATUS_ONLY(state, data) {
		state.statusOnly = data;
	},
	ADD_STATUS_MOBILE(state, statusMobile) {
		state.statusMobile.unshift(statusMobile);
	},
	// Actualizar status modificado en el state
	UPDATE_STATUS(state, data) {
		let findIndex = state.status.findIndex((p) => p.id === data.id);
		state.status[findIndex] = data;
	},
	// elimina el Status seleccionado del state
	REMOVE_STATUS(state, itemId) {
		const ItemIndex = state.statusMobile.findIndex((p) => p.id === itemId);
		state.statusMobile.splice(ItemIndex, 1);
	},
};
